import { cn as l } from "../../../lib/shadcn/utils/utils.js";
import { Fragment as n, jsx as a, jsxs as m } from "react/jsx-runtime";
var o = ({ label: e, children: r, className: s, labelClassName: t }) => /* @__PURE__ */ m(n, { children: [/* @__PURE__ */ a("span", {
  className: l("text-caption-2 text-secondary-700", t),
  children: e
}), /* @__PURE__ */ a("span", {
  className: s,
  children: r
})] });
o.displayName = "LabelValue";
export {
  o as LabelValue
};

//# sourceMappingURL=LabelValue.js.map